import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { ITheme } from '../../../../theme/types';

const HtmlTooltip = withStyles((theme: ITheme) => ({
  tooltip: {
    backgroundColor: 'white',
    color: 'rgb(0, 0, 0 )',
    maxWidth: 220,
    padding: '1.5em',
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default HtmlTooltip;
